import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome';

import { library } from '@fortawesome/fontawesome-svg-core';

import { faGoogle } from '@fortawesome/free-brands-svg-icons';

import {
  faCheckCircle,
  faSquare,
  faCalendarAlt,
  faCalendarCheck,
  faCalendarPlus,
  faUserCircle,
  faCircleCheck,
  faCopy,
  faPenToSquare,
  faCircleQuestion,
  faHeart,
  faUser as faUserRegular,
  faEye,
  faFloppyDisk,
  faCheckSquare,
} from '@fortawesome/free-regular-svg-icons';

import {
  faAngleDown,
  faCaretDown,
  faCaretUp,
  faCheck,
  faStar,
  faBook,
  faStarHalf,
  faCloudArrowDown,
  faSquare as faSquareSolid,
  faHome,
  faMessage,
  faTicketAlt,
  faExclamationCircle,
  faExclamationTriangle,
  faTimes,
  faChevronRight,
  faChevronLeft,
  faInfoCircle,
  faUserFriends,
  faUserCheck,
  faSignOutAlt,
  faShoppingCart,
  faLocationDot,
  faCircleCheck as faCircleCheckSolid,
  faVideo,
  faEllipsis,
  faQrcode,
  faCalendarDay,
  faCalendarCheck as faCalendarCheckSolid,
  faClock,
  faArrowLeft,
  faCalendar,
  faCalendarTimes,
  faCalendarDays,
  faBars,
  faAngleUp,
  faUser,
  faUserXmark,
  faCameraRotate,
  faHeart as faHeartSolid,
  faPlus,
  faCommentSlash,
  faComments,
  faCommentDots,
  faEyeSlash,
  faTrashRestore,
  faReply,
  faTrashCan,
  faDownLeftAndUpRightToCenter,
  faSearch,
  faUpload,
  faDownload,
  faArrowRight,
  faArrowDown,
  faExternalLinkAlt,
  faArrowRightArrowLeft,
  faPaperPlane,
  faUsd,
  faGears,
  faPhone,
  faEnvelope,
  faGripVertical,
  faGift,
  faRotate,
  faRefresh,
  faUserGroup,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faAngleDown,
  faCheck,
  faCheckCircle,
  faStar,
  faBook,
  faCaretDown,
  faCaretUp,
  faStarHalf,
  faSquare,
  faSquareSolid,
  faHome,
  faMessage,
  faCalendarAlt,
  faCloudArrowDown,
  faCalendarTimes,
  faCalendarCheck,
  faCalendarPlus,
  faCalendarDay,
  faTicketAlt,
  faExclamationCircle,
  faExclamationTriangle,
  faTimes,
  faChevronRight,
  faChevronLeft,
  faInfoCircle,
  faUserFriends,
  faUserCircle,
  faUserCheck,
  faSignOutAlt,
  faShoppingCart,
  faLocationDot,
  faCircleCheck,
  faCircleCheckSolid,
  faCheckSquare,
  faPenToSquare,
  faGoogle,
  faVideo,
  faEllipsis,
  faQrcode,
  faCalendarCheckSolid,
  faClock,
  faArrowLeft,
  faCalendar,
  faCalendarDays,
  faBars,
  faAngleUp,
  faUser,
  faUserXmark,
  faCircleQuestion,
  faCameraRotate,
  faPlus,
  faCopy,
  faTrashCan,
  faHeart,
  faHeartSolid,
  faEyeSlash,
  faComments,
  faCommentDots,
  faCommentSlash,
  faTrashRestore,
  faReply,
  faDownLeftAndUpRightToCenter,
  faSearch,
  faUpload,
  faDownload,
  faArrowRight,
  faArrowDown,
  faExternalLinkAlt,
  faArrowRightArrowLeft,
  faUserRegular,
  faEye,
  faPaperPlane,
  faUsd,
  faGears,
  faPhone,
  faEnvelope,
  faFloppyDisk,
  faGripVertical,
  faGift,
  faRotate,
  faRefresh,
  faUserGroup
);

export default function SetupFontAwesome(app) {
  /**
   * Register our FontAwesome component
   * https://github.com/FortAwesome/vue-fontawesome
   */
  app.component('font-awesome-icon', FontAwesomeIcon);
  app.component('font-awesome-layers', FontAwesomeLayers);

  return app;
}
